/* unplugin-vue-components disabled */import { render } from "./SvgIconCross.vue?vue&type=template&id=bf2db9fe"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__